import './styles.scss';
import 'highlight.js/scss/base16/dark-violet.scss';

import { useEffect, useState } from 'react';

import Renderer from './components/Renderer.js';
import Logo from './components/Logo.js';
import ButtonCustomize from './components/ButtonCustomize.js';
import ProfileBadge from './components/ProfileBadge.js';
import Configurator from './components/Configurator.js';
import Mml from './components/Mml.js';
import AvatarLoader from './scripts/avatar-loader.js';
import { render as renderPortrait } from './scripts/portrait.js';


function App() {
    const [app, setApp] = useState(null);
    const [data, setData] = useState(null);
    const [avatarLoader, setAvatarLoader] = useState(null);
    const [portrait, setPortrait] = useState(null);

    useEffect(() => {
        const loadData = async () => {
            const res = await fetch('/data.json');
            const raw = await res.json();
            setData(raw);
        };
        loadData();
    }, []);

    useEffect(() => {
        if (!app || !data || avatarLoader) return;
        // this should be created only once
        setAvatarLoader(new AvatarLoader(app, data));
    }, [app, data]);


    const onSave = () => {
        if (!app) return;
        renderPortrait(app, (image) => {
            setPortrait(image);
        });
    };


    return (
        <>
            {/* This should not be re-created */}
            <Renderer onInitialize={setApp} />

            <div className='spinner'></div>

            <Logo />

            {data && avatarLoader && <ButtonCustomize label="Customize" />}

            <ProfileBadge portrait={portrait} />

            {data && avatarLoader && <Configurator className='configurator' data={data} avatarLoader={avatarLoader} />}

            {data && avatarLoader && <Mml onSave={onSave} />}
        </>
    );
}

export default App;
